import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { toggleContentItemVisibility as toggleContentItemVisibilityAPI } from '@/api/v4/content-items.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';

export const useToggleContentItemVisibility = () => {
  const { t } = useTranslation('feed');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: toggleContentItemVisibilityAPI,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ContentItems] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.FeedContentItems],
        }),
      ]);
      notify({
        message: t`updateSuccess`,
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`updateError`,
      });
      console.error(error.message);
    },
  });

  return {
    toggleContentItemVisibility: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
